import { render, staticRenderFns } from "./SystemPermissionGroupManageDetailByRentalcompany.vue?vue&type=template&id=e4443aa0&scoped=true"
import script from "./SystemPermissionGroupManageDetailByRentalcompany.vue?vue&type=script&lang=js"
export * from "./SystemPermissionGroupManageDetailByRentalcompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4443aa0",
  null
  
)

export default component.exports